import { useParams, Link } from "react-router-dom";
import { useState, useEffect , React }  from "react";
import axios from "axios";
import baseURL from "./manager/apiConfig.js";
import { Carousel } from "react-bootstrap";
import "./css/ProductDetail.css";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css"; // 載入樣式文件
import Dropdown from 'react-bootstrap/Dropdown';
import QuantityBtn from './QuantityBtn';
import Nav from 'react-bootstrap/Nav';
import YouTube from 'react-youtube';

export default function ProductDetail() {
    let params = useParams();
    const [productDetail, setProductDetail] = useState(null);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [lightboxIndex, setLightboxIndex] = useState(0);
    const [selectedDegree, setSelectedDegree] = useState(null); // 新增一个状态来存储当前选中的度数
    const [activeTab, setActiveTab] = useState(1);

    useEffect(() => {
        const getProductDetail = () => {
            axios.get(`${baseURL}/productCRUD/${params.id}`).then(function (response) {
                console.log(response.data);
                setProductDetail(response.data);
            });

        };

        getProductDetail();
    }, [params.id]);

    const handleThumbnailClick = (index) => {
        setSelectedIndex(index);
    };

    const openLightbox = (index) => {
        setLightboxIndex(index);
        setLightboxOpen(true);
    };

    const handleDegreeSelect = (degree) => {
        setSelectedDegree(degree); // 更新选中的度数
    };

    const handleTabClick = (tabNumber) => {
        setActiveTab(tabNumber);
    };

    const getYouTubeVideoId = (url) => {
        // 匹配 YouTube 影片 URL 的正則表達式
        const regExp = /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
        
        // 使用正則表達式匹配 URL 並返回影片 ID
        const match = url.match(regExp);
        if (match && match[1]) {
            return match[1];
        } else {
            // 如果未找到匹配，返回空字符串或者其他預設值
            return '';
        }
    };

    return (
        <div style={{ position: "relative", top: "120px" }}>
            <div className="block-inner">
                <div className="ProductDetail-product row">
                    <div className="ProductDetail-product-gallery col-xs-12 col-md-6">
                        <div className="variant-gallery-stage text-center product-image-container">
                        {/* 顯示大圖 */}
                        <Carousel activeIndex={selectedIndex} onSelect={(selectedIndex) => setSelectedIndex(selectedIndex)}>
                            {productDetail && productDetail.map((product, index) => (
                                // 檢查 product.product_img 是否為 null
                                product.product_img && (
                                    <Carousel.Item key={index}>
                                        <img
                                            src={process.env.PUBLIC_URL + '/img/' + product.product_img}
                                            alt={`Product Image ${index + 1}`}
                                            width="450"
                                            onClick={() => openLightbox(index)} // 點擊大圖時觸發 Lightbox
                                        />
                                    </Carousel.Item>
                                )
                            ))}
                        </Carousel>

                        </div>
                        {/* 顯示縮圖 */}
                        <div className="thumbnails-container">
                            {productDetail && productDetail.map((product, index) => (
                                // 檢查 product.product_img 是否為 null
                                product.product_img && (
                                <img
                                    key={index}
                                    src={process.env.PUBLIC_URL + '/img/' + product.product_img}
                                    alt={`Product Thumbnail ${index + 1}`}
                                    className="thumbnail"
                                    onClick={() => handleThumbnailClick(index)}
                                />
                                )
                            ))}
                        </div>
                    </div>

                    {/* 度數選擇 */}
                    {productDetail && (
                        <div className="ProductDetail-product-info col-xs-12 col-md-3">
                            <div className="box-default">
                                <h2 className="Product-title mb-3" style={{ textAlign: "left" }}>{productDetail[0].商品名稱}</h2>
                                <p className="mb-3" style={{ borderBottom: "1px solid black", paddingBottom: "10px" }}>※{productDetail[0].注意事項}</p>
                                <div className="price-box bg-light mb-4">
                                    <div className="global-primary dark-primary price-regular price js-price ms-3 mb-3 mt-3">NT${productDetail[0].售價}</div>
                                </div>
                                <>
                                    <Dropdown>
                                        <Dropdown.Toggle variant="success" id="dropdown-basic">
                                            {selectedDegree ? selectedDegree + "度" : "選擇度數"} {/* 根据选中的度数显示不同的内容 */}
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                        {productDetail[0].度數.split(",").map((degree, index) => (
                                            <Dropdown.Item key={index} onClick={() => handleDegreeSelect(degree)}>{degree}度</Dropdown.Item>
                                        ))}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </>
                                <p>{productDetail[0].產品特色}</p><br />
                                <QuantityBtn productInfo={productDetail[0]} />
                            </div>
                        </div>
                    )}
                </div>
            </div>

            

            {/* 商品詳細介紹 */}
            <Nav variant="tabs" defaultActiveKey="/home" className="d-flex justify-content-center">
            <Nav.Item>
                <Nav.Link 
                    onClick={() => handleTabClick(1)} 
                    className={`Tab-label js-tab-label ${activeTab === 1 ? 'active' : ''}`}>
                    商品特色
                </Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link 
                    onClick={() => handleTabClick(2)} 
                    className={`Tab-label js-tab-label ${activeTab === 2 ? 'active' : ''}`}>
                    商品規格
                </Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link 
                    onClick={() => handleTabClick(3)} 
                    className={`Tab-label js-tab-label ${activeTab === 3 ? 'active' : ''}`}>
                    送貨及付款方式
                </Nav.Link>
            </Nav.Item>
            </Nav>
            <div className="ProductDetail-additionalInfo row" style={{ marginTop: '20px' }}>
                <div className="col-xs-12">
                    <section className="Tabset js-tabset" id="UAOFVFNW">
                        
                        <div className="Tab-content js-tab-content" id="tabset-tab-UAOFVFNW-1" scroll-to="" scroll-offset="48">
                            {activeTab === 1 && (
                                <div className="ProductDetail-description">
                                    <div className="ProductDetail-title primary-border-color-after">
                                        商品特色
                                    </div>
                                    {/* 使用 map 顯示出productDetail.product_features的所有圖片 */}
                                    {productDetail && productDetail.map((product, index) => (
                                        product.product_features && (
                                        <div key={index} className="product-feature">
                                            {product.product_features && product.product_features.includes('youtube.com') ? (
                                                <YouTube
                                                    videoId={getYouTubeVideoId(product.product_features)}
                                                    // opts={/* YouTube 播放器選項 */}
                                                />
                                            ) : product.product_features.includes('.jpg') ? (
                                                <img
                                                    src={process.env.PUBLIC_URL + '/img/' + product.product_features}
                                                    alt={`Product Feature ${index + 1}`}
                                                    style={{ maxWidth: '70%', height: 'auto' }}
                                                />
                                            ) : (
                                                <div className="mt-3 mb-3" style={{ fontWeight: 'bold' }}>{product.product_features}</div>
                                            )}
                                        </div>
                                        )
                                    ))}  
                                    
                                    {/* 商品描述的內容 */}
                                </div>
                            )}
                            {activeTab === 2 && (
                                <div className="ProductDetail-description">
                                    <div className="ProductDetail-title primary-border-color-after">
                                        商品規格
                                    </div>
                                    {/* 送貨及付款方式的內容 */}
                                </div>
                            )}
                            {activeTab === 3 && (
                                <div className="ProductDetail-description">
                                    <div className="ProductDetail-title primary-border-color-after">
                                        送貨及付款方式
                                    </div>
                                    {/* 送貨及付款方式的內容 */}
                                </div>
                            )}
                           
                        </div>
                    </section>
                </div>
            </div>

            {/* Lightbox */}
            {lightboxOpen && (
                <Lightbox
                    mainSrc={process.env.PUBLIC_URL + '/img/' + productDetail[lightboxIndex].product_img}
                    nextSrc={process.env.PUBLIC_URL + '/img/' + productDetail[(lightboxIndex + 1) % productDetail.length].product_img}
                    prevSrc={process.env.PUBLIC_URL + '/img/' + productDetail[(lightboxIndex + productDetail.length - 1) % productDetail.length].product_img}
                    onCloseRequest={() => setLightboxOpen(false)}
                    onMovePrevRequest={() => setLightboxIndex((lightboxIndex + productDetail.length - 1) % productDetail.length)}
                    onMoveNextRequest={() => setLightboxIndex((lightboxIndex + 1) % productDetail.length)}
                    imagePadding={400} // 設置圖片的內邊距
                />
            )}

            {/* 返回按鈕 */}
            <Link to="/">
                <div className="backToGoodsListBtn">↩️ 返回商品列表</div>
            </Link>
        </div>
    );
}
